import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { useUploadFile } from 'providers/SocketioProvider/chat/selectors';
import EntityType from 'constants/entity';
import { addMessage } from 'providers/SocketioProvider/chat/actions';
import { MessageType } from 'providers/SocketioProvider/chat/config';

interface IUploadImageButtonProps {
  chatgroupId: string;
}

const UploadImageButton = ({ chatgroupId }: IUploadImageButtonProps) => {
  const fileRef = React.useRef<any>();
  const { mutate: uploadFileMutation, isLoading } = useUploadFile({
    onSuccess: (response) => {
      addMessage({
        type: MessageType.image,
        message: response.data.path,
        chatGroupGuid: chatgroupId,
      });
    },
  });

  function handleUpload(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      Array.from(event.currentTarget.files).map(async (file: File) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          if (reader.result) {
            // const filePreview = {
            //   file: file,
            //   url: reader.result as string,
            //   name: file.name,
            // };
            uploadFileMutation({
              entityType: EntityType.Chat,
              file,
            });
            // setPreviewsImg((prv: FilePreview[]) => [...prv, filePreview]);
          }
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      });
    }
    (fileRef.current as any).value = '';
  }

  return (
    <>
      <Tooltip title="Upload Image">
        <IconButton
          size="small"
          style={{ marginRight: '0.4rem' }}
          onClick={() => {
            if (fileRef.current) {
              (fileRef.current as any).click();
            }
          }}
        >
          <AttachmentIcon />
        </IconButton>
      </Tooltip>
      <input
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleUpload}
        ref={fileRef}
      />
    </>
  );
};

export default React.memo(UploadImageButton);
